import './navigation';
import './form-thank-you';
import './loadmore';
window.addEventListener("DOMContentLoaded", () => {
	AOS.init({
		duration: 1000,
		delay: 100,
		once: true
	})
});
